import React from "react";
import {TiStarburst} from "react-icons/ti";

const StarburstIcon = () => {

    return (
        <span style={{ position: 'relative', display: 'inline-block'}}>
      <TiStarburst className="starburst_icon" />
      <span className="starburst_icon_text">NEW</span>
    </span>
    );
};

export default StarburstIcon;